export default __webpack_public_path__ + "static/media/frequency_green.cfbf7bd0.png";